import { InstanceTypeOf } from '@/type-utils';
import { errorFactory } from '@/utils/error-utils';

export const { BreakpointGroupError } = errorFactory('BreakpointGroupError');

/** An error that occurs when there is a problem with a breakpoint group. */
export type BreakpointGroupError = InstanceTypeOf<typeof BreakpointGroupError>;
